import { LoadablePaint, MustPreloadLoadableNames } from '@confluence/loadable';

export const LivePageComponentLoader = LoadablePaint({
	name: MustPreloadLoadableNames.LivePageComponentLoader,
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-LivePageComponent" */ '../src/LivePageComponent.tsx'
			)
		).LivePageComponent,
});
